import HereTokenManager from 'auth/HereTokenManager';

export const Olathe = [38.854699, -94.797763];

export const getLocationByCoordinates = (
    coords,
    { limit = 20, userLocale = 'en-US', includeTimeZoneInfo = false },
    callback
) => {
    HereTokenManager.getToken().then((hereToken) => {
        fetch(
            `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${coords[0]},${coords[1]}&lang=${userLocale}${
                includeTimeZoneInfo ? '&show=tz' : ''
            }`,
            {
                headers: {
                    Authorization: `Bearer ${hereToken}`
                }
            }
        )
            .then((response) => response.json())
            .then((data) => {
                let results = [];
                if (data.items) {
                    data.items.forEach((item) => {
                        if (item.address && item.position) {
                            const addressList = [];
                            if (item.address.city) {
                                addressList.push(item.address.city);
                            }
                            addressList.push(item.address.countryName);

                            const result = {
                                address: addressList.join(', '),
                                location: [item.position.lat, item.position.lng],
                                unFormattedAddress: item.address
                            };
                            if (includeTimeZoneInfo) {
                                result.timezone = item.timeZone;
                            }

                            results.push(result);
                        }
                    });
                }

                callback(results);
            });
    });
};
